import gql from "graphql-tag";

export const companyLoginDetails = gql `
  query companyLoginD($userId: Int!, $token: String!) {
    CompanyLoginD(userId: $userId, token: $token) {
      username
      targetId
      enabled
    }
    EnabledTargets(token: $token) {
      id
      name
      logo
    }
    AstuteDetails(userId: $userId, token: $token) {
      username,
      enabled
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/Profile/queries.js